import React from 'react'
import classNames from 'classnames'
import style from './styles/new.module.scss'
import { GxIcon } from '@garpix/garpix-web-components-react'
import { starIcon } from '@/images'

const NewLabel = ({ side = 'right', className = '' }): React.ReactElement => {
  return (
    <span
      className={classNames({
        [style.new]: true,
        [style[`side_${side}`]]: side,
        [className]: className
      })}
    >
      <GxIcon src={starIcon} className={style.new__icon} />
      Новая игра
    </span>
  )
}

export default NewLabel
